import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostBinding,
  ElementRef,
  Inject,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Directionality } from '@angular/cdk/bidi';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';

import { SettingsService, AppSettings } from '@core';
import { AppDirectionality } from '@shared';
import { AuthService } from 'app/auth-guard/auth.service';
import { TabService } from './tabsmenu/tabservice';

const MOBILE_MEDIAQUERY = 'screen and (max-width: 599px)';
const TABLET_MEDIAQUERY = 'screen and (min-width: 600px) and (max-width: 959px)';
const MONITOR_MEDIAQUERY = 'screen and (min-width: 960px)';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
  @ViewChild('content', { static: true }) content: MatSidenavContent;

  options = this.settings.getOptions();
  public loader:boolean = false;
  private layoutChanges: Subscription;

  private isMobileScreen = false;
  get isOver(): boolean {
    return this.isMobileScreen;
  }

  private contentWidthFix = true;
  @HostBinding('class.matero-content-width-fix') get isContentWidthFix() {
    return (
      this.contentWidthFix &&
      this.options.navPos === 'side' &&
      this.options.sidenavOpened &&
      !this.isOver
    );
  }

  private collapsedWidthFix = true;
  @HostBinding('class.matero-sidenav-collapsed-fix') get isCollapsedWidthFix() {
    return (
      this.collapsedWidthFix &&
      (this.options.navPos === 'top' || (this.options.sidenavOpened && this.isOver))
    );
  }
  showsettingpanel:any;
  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private overlay: OverlayContainer,
    private element: ElementRef,
    private settings: SettingsService,
    public authserice:AuthService,
    public tabservice:TabService,
    @Inject(Directionality) public dir: AppDirectionality
  ) {

    this.toggle_dttheme(this.authserice.getlocalstoragevalues('themestate'));
    
    this.tabservice.resettab();
    
    this.overlay.getContainerElement().classList.remove('theme-light');  
    if(this.authserice.getlocalstoragevalues('navstate') == 'top')
    {
      this.settings.setLayout({navPos:'top'});
    }
    if(this.authserice.getlocalstoragevalues('navstate') == 'top' || this.authserice.getstoragedtl().user_role == 'PC')
    {
      this.settings.setLayout({navPos:'top'});
    }
    if(this.authserice.getlocalstoragevalues('themestate') == 'light')
    {
      this.element.nativeElement.classList.add('theme-light');
      this.overlay.getContainerElement().classList.add('theme-light');
      this.settings.setLayout({theme:'light'});
      
    }

    this.layoutChanges = this.breakpointObserver
      .observe([MOBILE_MEDIAQUERY, TABLET_MEDIAQUERY, MONITOR_MEDIAQUERY])
      .subscribe(state => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;

        this.isMobileScreen = state.breakpoints[MOBILE_MEDIAQUERY];
        this.options.sidenavCollapsed = state.breakpoints[TABLET_MEDIAQUERY];
        this.contentWidthFix = state.breakpoints[MONITOR_MEDIAQUERY];
      });

    // TODO: Scroll top to container
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.content.scrollTo({ top: 0 });
      }
    });
  }

  ngOnInit() {
    setTimeout(() => (this.contentWidthFix = this.collapsedWidthFix = false));
    setTimeout(() => {
      this.authserice.loadersub.subscribe(status => {
        this.loader = status;
      });
    });
  }

  ngOnDestroy() {
    this.layoutChanges.unsubscribe();
  }

  toggleCollapsed() {
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    // TODO: Trigger when transition end
    setTimeout(() => {
      this.settings.setNavState('collapsed', this.options.sidenavCollapsed);
    }, timer);
  }

  sidenavCloseStart() {
    this.contentWidthFix = false;
  }

  sidenavOpenedChange(isOpened: boolean) {
    this.options.sidenavOpened = isOpened;
    this.settings.setNavState('opened', isOpened);

    this.collapsedWidthFix = !this.isOver;
    this.resetCollapsedState();
  }

  // Demo purposes only
  receiveOptions(options: AppSettings): void {
    console.log(options);
    this.options = options;
    this.toggleDarkTheme(options);
    this.toggleDirection(options);
    this.authserice.localstorageupdate('themestate',options.theme);
    this.authserice.localstorageupdate('navstate',options.navPos);
  }

  toggleDarkTheme(options: AppSettings) {
    this.toggle_dttheme(options.theme);
    if (options.theme === 'light') {
      this.element.nativeElement.classList.add('theme-light');
      this.overlay.getContainerElement().classList.add('theme-light');
    } else {
      this.element.nativeElement.classList.remove('theme-light');
      this.overlay.getContainerElement().classList.remove('theme-light');
    }
  }
  toggle_dttheme(color)
  {
    
    if(color == 'light')
    {
      document.documentElement.style.setProperty('--dt-bgcolor', "white");
      document.documentElement.style.setProperty('--dt-bordercolor', "lightgrey");
      document.documentElement.style.setProperty('--dt-fontcolor', "black");
      document.documentElement.style.setProperty('--dt-thfontcolor', "#888888");
      document.documentElement.style.setProperty('--dt-colvisbg', "#ff4081");
      document.documentElement.style.setProperty('--dt-tabbg', "#fafafa");
    }
    else{
      document.documentElement.style.setProperty('--dt-bgcolor', "#424242");
      document.documentElement.style.setProperty('--dt-bordercolor', "#575757");
      document.documentElement.style.setProperty('--dt-fontcolor', "#f0f0f0");
      document.documentElement.style.setProperty('--dt-thfontcolor', "#c2c2c2");
      document.documentElement.style.setProperty('--dt-colvisbg', "#ffd740");
      document.documentElement.style.setProperty('--dt-tabbg', "#303030");
    }
  }
  toggleDirection(options: AppSettings) {
    this.dir.value = options.dir;
  }

  getshowsetting(val){
    if(this.showsettingpanel)
    {
      this.showsettingpanel = false;
    }
    else{
      this.showsettingpanel = true;
    }
  
 
  }
}
